import type { ComputedRef } from 'vue'

import { useDisciplineStore } from '@entities/customer'

import { trackClassroomEvent } from '../lib/classroom'

interface ClassroomLearningPlatformReturn {
  label: string
  isVisible: ComputedRef<boolean>
  handleClick: () => void
}

const LINK_NAME = 'to_learning_platform'

export const useClassroomLearningPlatform = (): ClassroomLearningPlatformReturn => {
  const disciplineStore = useDisciplineStore()

  const label = 'Learning platform'

  const isVisible = computed<boolean>(() => {
    return disciplineStore.hasLearningPlatformAccess && !!disciplineStore.getLearningPlatformUrl
  })

  const handleClick = (): void => {
    const url = disciplineStore.getLearningPlatformUrl
    if (!url) return

    trackClassroomEvent('Link_click', {
      name: LINK_NAME,
      text: label,
    })

    window.open(url, '_blank', 'noopener')
  }

  return {
    label,
    isVisible,
    handleClick,
  }
}
